import * as IMG from '@Utils/Images';

export default function Component() {
  return (
    <div className="container mt-5">
      <div className="row gap-5 justify-content-center align-items-center">
        <div className="col-lg-5 px-0">
          <img
            src={IMG.STORE}
            className="card-img-top"
            alt="Store"
          />
        </div>
        <div className="col-lg-5 p-0 mt-md-4">
          <h3 className="mb-4 fw-bolder">Sejarah Toko Bhevin</h3>
          <p className="normal">
            Toko Bhevin didirikan oleh lima developer pada Senin, 5 September
            2022. Tujuan didirikan toko online ini adalah untuk menjembatani
            User atau Customer untuk membeli sebuah produk tanpa harus ke
            tempatnya langsung, karena faktor jarak jauh atau pada saat kondisi
            yang tidak memungkinkan.
          </p>
        </div>
      </div>
    </div>
  );
};
